import styled from 'styled-components'
import { colors, media, updatedMedia } from 'client/styles'
import { PaymentFormBase } from 'src/comps/PaymentForm/styles'

export const PaymentInformationBase = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: ${colors.white};
  border: 2px solid ${colors.grey4};
  border-radius: 8px;
  width: 100%;
  padding-block: 20px;
  padding-inline: 20px;
  min-height: 130px;

  ${media.desktop} {
    max-width: 430px;
  }
`

export const Row = styled.div`
  display: flex;

  padding-block-start: 20px;
  width: 100%;
`

export const PaidSection = styled.div`
  width: 100%;

  ${props => props.separator && `border-block-end: 1px solid ${colors.grey4}`}
`

export const Transaction = styled.div`
  display: flex;
  flex-direction: column;

  padding-block-end: 16px;
  width: 100%;
`

export const CreditCardInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  width: 100%;
`

export const PaymentDescription = styled.div`
  display: flex;
  text-transform: capitalize;
  font-size: 16px;
  line-height: 150%;

  color: ${colors.grey2};
`

export const PaymentDescriptionBold = styled(PaymentDescription)`
  font-weight: 700;
`

export const PaymentTotal = styled.div`
  display: flex;
  padding-block-end: 4px;
  font-size: 16px;
  line-height: 150%;

  color: ${colors.grey2};
`

export const PaymentInformationTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
  text-transform: capitalize;

  color: ${colors.grey1};
  padding-block-end: 20px;
`

export const PendingPaymentTitle = styled(PaymentInformationTitle)`
  font-size: 16px;
  line-height: 150%;

  padding-block: 16px 0;
  padding-inline: 0;
`

export const PendingSection = styled.div`
  width: 100%;

  ${PaymentFormBase} {
    margin-block-start: 20px;
  }

  ${updatedMedia.onlyMobile} {
    ${PaymentFormBase} {
      padding-block: 0;
      padding-inline: 0;
    }
  }
`

export const PendingValue = styled.div`
  display: flex;
  padding-block-end: 4px;
  font-weight: 700;
`

export const CreditCardNumberLabel = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  padding-block-end: 4px;

  color: ${colors.grey1};
`

export const CreditCardNumberValue = styled.div`
  font-size: 16px;
  line-height: 150%;
  padding-block-end: 4px;
`

export const FeedbackSection = styled.div`
  display: flex;
  flex-direction: column;

  padding-block-start: 20px;
`
